import { HoverLink } from '@campfire/hover-link';
import { TitularTooltip } from '@campfire/titular-tooltip';
import { Typography, ListItemText, ListItem, ListItemIcon, Box, Divider, Grid } from '@material-ui/core';
import { Event, Link as LinkIcon } from '@material-ui/icons';
import React, { memo } from 'react';
import { VolunteerCommonProfileActivityWaitlisting } from '../__generated__/VolunteerCommonProfileActivityWaitlisting';
import { useVolunteerCommonProfileContext } from '../VolunteerCommonProfileContext';

export const VolunteerActivityWaitlistingsSection = memo(
  ({ activityWaitlistings }: { activityWaitlistings: VolunteerCommonProfileActivityWaitlisting[] }) => {
    const {
      volunteerNameOptions: { preferredName },
    } = useVolunteerCommonProfileContext();
    return (
      <Grid container spacing={2} direction='column' style={{ position: 'relative' }}>
        <Grid item xs={12} style={{ textAlign: 'left' }}>
          <Typography
            style={{ fontWeight: 600, fontSize: '18px', display: 'flex', alignItems: 'center', color: '#333' }}
          >
            <Event style={{ fontSize: '14px', paddingRight: '5px' }} /> Activity Waitlistings
          </Typography>
          <Typography variant='body2' style={{ color: '#464646' }} align='left'>
            Activities that {preferredName} is waitlisted for
            <hr style={{ borderTop: '.5px solid #e7e7e7', margin: '20px 0' }} />
          </Typography>
          {activityWaitlistings
            .filter((activityWaitlisting) => activityWaitlisting.activityWaitlistingId !== null)
            .map((activityWaitlisting, idx) => (
              <HoverLink
                data-track='fs-volPrf-activity-waitlisting-item'
                key={activityWaitlisting.activityWaitlistingId}
                hoverColor='primary'
                to={`/management/activity-management?activityId=${activityWaitlisting.activity.activityId}&programId=${activityWaitlisting.activity.program.programId}`}
                disableUnderline
              >
                <TitularTooltip description='Open Activity Overview'>
                  <Box key={activityWaitlisting.activityWaitlistingId}>
                    <ListItem key={activityWaitlisting.activityWaitlistingId} button>
                      <ListItemIcon>
                        <LinkIcon color='disabled' />
                      </ListItemIcon>
                      <ListItemText
                        primary={activityWaitlisting.activity.name}
                        secondary={activityWaitlisting.activity.program.name}
                      />
                    </ListItem>
                    {idx !== activityWaitlistings.length - 1 && <Divider style={{ marginTop: '8px' }} />}
                  </Box>
                </TitularTooltip>
              </HoverLink>
            ))}
          {activityWaitlistings.length === 0 && (
            <Typography
              variant='body2'
              style={{ fontSize: '13px', color: '#494949', textAlign: 'center', padding: '2rem 0' }}
            >
              No results found
            </Typography>
          )}
        </Grid>
      </Grid>
    );
  }
);
